import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(12 * 60 + 32); // 12:32 in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) {
          // Reset to random time between 8-15 minutes
          return Math.floor(Math.random() * (15 - 8 + 1) + 8) * 60;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <span className="font-black text-white bg-black/40 rounded px-2 py-0.5 tracking-widest text-sm md:text-base" data-id="element-328">
      {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
    </span>;
}